"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.currentlySmokingMessages = exports.CurrentlySmoking = void 0;
const schema_1 = require("../../../schema");
var CurrentlySmoking;
(function (CurrentlySmoking) {
    CurrentlySmoking["YES"] = "YES";
    CurrentlySmoking["NO"] = "NO";
})(CurrentlySmoking || (exports.CurrentlySmoking = CurrentlySmoking = {}));
exports.currentlySmokingMessages = {
    [CurrentlySmoking.YES]: {
        id: "htx.risks.smoking.currentlySmoking.YES",
        defaultMessage: "Igen"
    },
    [CurrentlySmoking.NO]: {
        id: "htx.risks.smoking.currentlySmoking.NO",
        defaultMessage: "Nem"
    }
};
const currentlySmoking = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CurrentlySmoking.YES),
    schema_1.Schema.singleChoiceItem(CurrentlySmoking.NO)
])
    .interpretation({ vocab: "htx", code: "smoking" })
    .tag({ vocab: "snomed", code: "365981007" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ currentlySmoking });
